<div class="contact-page">
    <section class="contact-main">

      <div>
        <p class="contact-eyebrow">Contact CircledPlus / Let’s talk</p>
        <h1>Good decisions start<br>with a <span>conversation.</span></h1>
        <p class="contact-intro">
          Tell us what you’re looking for. Our team can help you explore properties, understand your options, and plan your next step.
        </p>

        <ul class="contact-details">
          <li class="flex items-center gap-5">
            <div class="w-6 h-6 flex items-center justify-center">
              <img class="w-12 h-12" src="assets/img/email.svg" alt="">
            </div>
            <span class="text-[#333333] font-normal text-xl"><a href="mailto:support@circled.co.in">support&#64;circled.co.in</a></span>
          </li>
          <li class="flex items-center gap-5">
            <div class="w-6 h-6 flex items-center justify-center">
              <img class="w-12 h-12" src="assets/img/address.svg" alt="">
            </div>
            <span class="text-[#333333] font-normal text-xl leading-relaxed">5th Block, HBR Layout, Service Road, <br />Outer Ring Rd, Bengaluru, <br /> Karnataka 560043</span>
          </li>
          <li class="flex items-center gap-5">
            <div class="w-6 h-6 flex items-center justify-center">
              <img class="w-12 h-12" src="assets/img/contact.svg" alt="">
            </div>
            <span class="text-[#333333] font-normal text-xl"><a href="tel:+918069069715">+91 806 906 9715</a></span>
          </li>
        </ul>
      </div>

      <div class="contact-form-card">
        <p class="contact-eyebrow">Your next step</p>
        <h2>How can we help?</h2>
        <p class="contact-form-intro">Share a little about your requirements.</p>
        <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="space-y-5">


          <div>
            <input
              type="text"
              formControlName="name" aria-label="Full name"
              placeholder="Name*"
              class="w-full bg-white rounded-xl px-6 py-3 box-shadow-ff focus:outline-none focus:ring-2 focus:ring-[#7C5CFF]/30 transition-all"
              [class.border-red-400]="f['name'].invalid && f['name'].touched"/>
            <p *ngIf="f['name'].errors?.['required'] && f['name'].touched"
              class="text-red-500 text-xs mt-1 pl-1">
              Name is required.
            </p>

            <p *ngIf="f['name'].errors?.['minlength'] && f['name'].touched"
              class="text-red-500 text-xs mt-1 pl-1">
              Name must be at least 2 characters.
            </p>

            <p *ngIf="f['name'].errors?.['pattern'] && f['name'].touched"
              class="text-red-500 text-xs mt-1 pl-1">
              Please enter a valid name.
            </p>
          </div>


          <div>
            <input
              type="email"
              formControlName="email" aria-label="Email address"
              placeholder="Email*"
              class="w-full bg-white rounded-xl px-6 py-3 box-shadow-ff focus:outline-none focus:ring-2 focus:ring-[#7C5CFF]/30 transition-all"
              [class.border-red-400]="f['email'].invalid && f['email'].touched"/>
            <p *ngIf="f['email'].errors?.['email'] && f['email'].touched" class="text-red-500 text-xs mt-1 pl-1">
              Please enter a valid email address.
            </p>
            <p *ngIf="f['email'].errors?.['required'] && f['email'].touched"
              class="text-red-500 text-xs mt-1 pl-1">
              Email is required.
            </p>
          </div>


          <div>

            <div
              class="flex items-center bg-white rounded-xl box-shadow-ff overflow-hidden focus-within:ring-2 focus-within:ring-[#7C5CFF]/30 transition-all"
              [class.border-red-400]="f['phone'].invalid && f['phone'].touched">


              <div class="relative border-r border-gray-200">
                <select
                  formControlName="countryCode" aria-label="Country calling code"
                  class="px-4 pr-10 py-4 bg-transparent border-r border-gray-200 focus:outline-none text-gray-700 font-medium cursor-pointer appearance-none min-w-[140px]">

                  <option *ngFor="let country of countryCodes" [value]="country.code">
                    {{ country.flag }} {{ country.code }}
                  </option>

                </select>

                <div class="absolute inset-y-0 right-4 flex items-center pointer-events-none">

                  <svg
                    class="w-4 h-4 text-gray-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24">

                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 9l-7 7-7-7"/>

                  </svg>

                </div>
              </div>


              <input
                type="tel"
                formControlName="phone" aria-label="Phone number"
                placeholder="Phone number*"
                class="w-full px-5 py-4 focus:outline-none text-gray-800 bg-transparent" />

            </div>


            <p
              *ngIf="f['phone'].errors?.['required'] && f['phone'].touched"
              class="text-red-500 text-xs mt-1 pl-1">

              Phone number is required.

            </p>

            <p
              *ngIf="f['phone'].errors?.['pattern'] && f['phone'].touched"
              class="text-red-500 text-xs mt-1 pl-1">

              Please enter a valid phone number.

            </p>

          </div>


          <div>
            <textarea
              rows="5"
              formControlName="message" aria-label="Your message"
              placeholder="Message*"
              class="w-full bg-white rounded-2xl px-6 py-5 box-shadow-ff focus:outline-none focus:ring-2 focus:ring-[#7C5CFF]/30 transition-all"
              [class.border-red-400]="f['message'].invalid && f['message'].touched"></textarea>
            <p *ngIf="f['message'].invalid && f['message'].touched" class="text-red-500 text-xs mt-1 pl-1">
              Message is required.
            </p>
            <p *ngIf="f['message'].errors?.['minlength'] && f['message'].touched"
              class="text-red-500 text-xs mt-1 pl-1">
              Message should be at least 10 characters.
            </p>
          </div>

          <button
            type="submit"
            [disabled]="isSubmitting"
            class="w-full bg-black text-white py-5 rounded-full font-bold text-xl hover:bg-[#111111] transition-all shadow-xl active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed">

            <span *ngIf="!isSubmitting">Submit</span>
            <span *ngIf="isSubmitting">Submitting...</span>

          </button>

        </form>
      </div>
    </section>

    <section class="contact-faq">
      <p class="contact-eyebrow">A little more clarity</p>
      <h2>Frequently asked questions.</h2>

      <div class="max-w-4xl mx-auto space-y-4">

        <div *ngFor="let item of faqs; let i = index" class="bg-white rounded-2xl px-6 py-5 shadow-sm">


          <button type="button" [attr.aria-expanded]="activeIndex === i" [attr.aria-controls]="'contact-faq-' + i" (click)="toggle(i)" class="w-full flex items-center justify-between text-left">

            <h3 class="text-lg font-semibold text-black">{{ item.question }}</h3>


            <svg
              class="w-5 h-5 text-purple-600 transition-transform duration-300"
              [class.rotate-180]="activeIndex === i"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7" />
            </svg>
          </button>


          <div [id]="'contact-faq-' + i" *ngIf="activeIndex === i" class="mt-4 text-gray-600 leading-relaxed grid transition-all duration-300 ease-in-out" [class.grid-rows-[1fr]]="activeIndex === i" [class.grid-rows-[0fr]]="activeIndex !== i">
            <div class="overflow-hidden">
              <p class="mt-4 text-gray-600 leading-relaxed transition-opacity duration-300"
                [class.opacity-100]="activeIndex === i"
                [class.opacity-0]="activeIndex !== i">
                {{ item.answer }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
</div>



<div
  *ngIf="showSuccessPopup"
  role="dialog" aria-modal="true" aria-label="Enquiry submitted" class="contact-success fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">

  <div
    class="bg-white max-w-lg w-full rounded-3xl p-8 text-center shadow-2xl animate-[fadeIn_.3s_ease]">


    <div class="w-20 h-20 mx-auto mb-6 rounded-full bg-green-100 flex items-center justify-center">
      <svg class="w-10 h-10 text-green-600"
           fill="none"
           stroke="currentColor"
           viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M5 13l4 4L19 7"/>
      </svg>
    </div>

    <h3 class="text-2xl font-bold text-gray-900 mb-4">
      Thank You!
    </h3>

    <p class="text-gray-600 leading-relaxed mb-8">
      Thank you for your request, we will reach out to you shortly.
      Meanwhile, feel free to browse our properties or call<br/>
      <a href="tel:08069069715"
         class="font-semibold text-black hover:underline">
        080 6906 9715
      </a>
      for immediate assistance.
    </p>

    <div class="flex flex-col sm:flex-row gap-4">

      <a
        routerLink="/search" (click)="closeSuccessPopup()"
        class="flex-1 bg-black text-white py-3 rounded-full font-semibold hover:bg-[#111111] transition-all cursor-pointer">
        Browse Properties
      </a>

      <button
        (click)="closeSuccessPopup()"
        class="flex-1 border border-gray-300 py-3 rounded-full font-semibold hover:bg-gray-100 transition-all">
        Close
      </button>

    </div>

  </div>

</div>
